import React, { PureComponent } from 'react'
import topicHero from '../images/discussion-topic-hero.jpg'
import tipsImg from '../images/discussion-topic-tips-header.png'
import DialogueQuestionBlock from './dialogue-question-block'
import NavBar from './navigation/nav-bar'
import ServerImage from './server-image'
import { Link } from 'react-router-dom'
import Affix from './Affix'
import { BsLightningFill } from 'react-icons/bs'
import { FaLock } from 'react-icons/fa'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import styled from 'styled-components'
import { TABLET } from '../utilities/breakpoints'
import { formPagePath } from '../utilities/route'

class dialoguePageTopic extends PureComponent {

  constructor(props) {
    super(props);
    this.questionRefs = []
    this.affixRef = React.createRef()
    this.state = {
      affixY : 0
    };
  }

  t = (phrase) => {
    const { useTranslate } = this.props
    return useTranslate(`discussion.${phrase}`)
  }

  scrollToQuestion = (index) => {
    this.questionRefs[index].scrollIntoView({ behavior: 'smooth' })
  }

  updateAffixY = () => {
    if(!this.affixRef.current.getBoundingClientRect().y < 0){
      this.setState({ affixY: this.affixRef.current.getBoundingClientRect().y });
    }
  };

  componentDidMount() {
    this.setState({ affixY: this.affixRef.current.getBoundingClientRect().y });
    window.addEventListener('resize', this.updateAffixY)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateAffixY)
  }

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      useTranslate,
      questionnaire: {
        logo,
        canViewAfterGame,
        isAfterGameGuest,
        isDialogueActive,
        areProgressReportsActive
      },
      afterGameDialogueTopic: { questions, active, tips, title, image },
      afterGameDialogueTopics,
      history,
      improvementProject,
    } = this.props;

    const to = formPagePath(languageCode, surveyId, 'finish');
    const toDiscussion = formPagePath(languageCode, surveyId, 'finish', 'dialogue');
    const closed = !active;

    // Handle redirects if discussion is not active
    if (!isDialogueActive && (canViewAfterGame || isAfterGameGuest)) {
      history.push(formPagePath(languageCode, surveyId, 'finish'));
    } else if (!isDialogueActive && !canViewAfterGame && !isAfterGameGuest) {
      history.push(formPagePath(languageCode, surveyId));
    }

    return (
      <section className="discussion-page">
        <DiscussionPageHeader>
          <div className="aftergame-page-container">
            <NavBar
              afterGame logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"discussion"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="discussion-page__container">
            <div className="discussion-breadcrumb">
              <Link to={toDiscussion}>{useTranslate("data_vault.discussion")}</Link>
              <span className="divider">&rsaquo;</span>
              <UncontrolledDropdown className="topic-dropdown">
                <DropdownToggle caret>
                  {title}
                </DropdownToggle>
                <DropdownMenu>
                  {afterGameDialogueTopics.map((topic, index) => {
                    return (
                      <DropdownItem
                        key={index}
                        onClick={() => history.push(`${to}/dialogue/topic/${topic.id}`)}
                      >
                        {topic.title}
                      </DropdownItem>
                    )
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
        </DiscussionPageHeader>
        <div className="discussion-page-topic">
          <div className="discussion-page__container">

          </div>
          <div className={`discussion-topic ${closed ? "closed" : ""}`}>
            <div className="discussion-topic-hero-img">
              <img src={topicHero} alt="hero"/>
              {image ? (
                <ServerImage image={image}>
                  {({ uri }) => (
                    <img src={uri} alt="Topic heroimage" />
                  )}
                </ServerImage>
              ) : (
                <img src={topicHero} alt="Topic heroimage"/>
              )}
            </div>
            <div className="discussion-topic-header">
              <div className="discussion-page__container">
                <h2>{title}</h2>
                <div className="topic-meta">
                  { !closed ?
                    <span className="state-indicator"><BsLightningFill/>{this.t("active_topic")}</span>
                    :
                    <span className="state-indicator"><FaLock/>{this.t("closed_topic")}</span>
                  }
                  <span className="divider-bullet"/>{questions.length} {this.t("questions")}
                </div>
              </div>
            </div>
            <div className="topic-content" style={{backgroundColor: 'transparent'}}>
              <div className="discussion-page__container">
                <div className="row">
                  <div className="col-12 col-md-8 col-questions">
                    {questions.map((i, index) => (
                      <div
                        ref={(ref) => {this.questionRefs[index] = ref}}
                        key={index}
                      >
                        <DialogueQuestionBlock
                          {...i}
                          closed={!i.active}
                          topicClosed={closed}
                          title={i.title}
                          questionNum={index}
                          isAfterGameGuest={isAfterGameGuest}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="col-12 col-md-4 col-sidebar" ref={this.affixRef}>
                    <Affix offset={this.state.affixY}>
                      {!!questions.length &&
                        <div className="questions-nav">
                          <h3 className="h5">{questions.length} {this.t("questions")}</h3>
                          <ul className="nav">
                            {questions.map((i, index) => (
                              <li className={`nav-item ${!i.active || closed ? "closed" : ""}`} onClick={() => this.scrollToQuestion(index)} key={index}>
                                {i.title}
                                <div className="question-meta">
                                  {i.comments.length} {this.t("answer_amount")}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      }
                      {!!tips.length &&
                        <div className="topic-tips">
                          <h3 className="h5">{this.t("tips")}</h3>
                          <img src={tipsImg} className="img-fluid" alt="People"/>
                          {tips.map((tip, index) => (
                            <div key={index} className="tip-item">
                              <p>{tip.text}</p>
                            </div>
                          ))}
                        </div>
                      }
                    </Affix>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    )
  }
}

export default dialoguePageTopic;

const DiscussionPageHeader = styled.div`
  background-color: #CCE2F2;
  padding-bottom: 1.5rem;
  
  @media${TABLET} {
    padding-bottom: 2rem;
  }
`;


// WEBPACK FOOTER //
// ./src/components/dialogue-page-topic.js